import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import {
    shiftDetailRequest, assignShiftRequest, assignShiftRequestStatus,
    removeShiftEmployeeRequest, removeShiftEmployeeRequestStatus, requestShiftRequest,
    requestShiftRequestStatus, declineRequestShiftRequest, declineRequestShiftRequestStatus,
    updateShiftRequest, updateShiftRequestStatus
} from '../../../redux/shift/shift.action'
import moment from "moment";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";

const ShiftDetail = props => {
    const { user } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { shiftDetailSuccess, shiftDetailError, updateShiftSuccess,
        updateShiftError, updateShiftReqStatus, assignShiftSuccess,
        assignShiftError, assignShiftReqStatus, requestShiftSuccess,
        requestShiftError, requestShiftReqStatus, shiftRemoveEmployeeSuccess,
        shiftRemoveEmployeeError, shiftRemoveEmployeeReqStatus, declineRequestSuccess,
        declineRequestError, declineRequestReqStatus
    } = useSelector(state => state.shift)
    const [selectedEmployee, setSelectedEmployee] = useState()
    const [showRejectModal, setShowRejectModal] = useState(false)
    const [reason, setReason] = useState('')
    const UPDATE_TYPE = {
        GENERAL: 'GENERAL',
        STATUS: 'STATUS',
        NOMINATION: 'NOMINATION'
    }

    useEffect(() => {
        fetchShiftDetail()
    }, [])

    const fetchShiftDetail = () => {
        setLoading(true)
        const data = {
            shiftId: state.shiftId,
            params: {
                businessId: state.businessId,
                locationId: state.locationId
            }
        }
        dispatch(shiftDetailRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(shiftDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(shiftDetailError)) {
            setLoading(false)
        }
    }, [shiftDetailSuccess, shiftDetailError])

    useEffect(() => {
        if (updateShiftReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateShiftSuccess.data.message)
            fetchShiftDetail()
        } else if (updateShiftReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateShiftError.message)
        }
        if (updateShiftReqStatus?.length) {
            dispatch(updateShiftRequestStatus(''))
        }
    }, [updateShiftSuccess, updateShiftError, updateShiftReqStatus])

    useEffect(() => {
        if (requestShiftReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(requestShiftSuccess.data.message)
            fetchShiftDetail()
        } else if (requestShiftReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(requestShiftError.message)
        }
        if (requestShiftReqStatus?.length) {
            dispatch(requestShiftRequestStatus(''))
        }
    }, [requestShiftSuccess, requestShiftError, requestShiftReqStatus])

    useEffect(() => {
        if (assignShiftReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(assignShiftSuccess.data.message)
            fetchShiftDetail()
        } else if (assignShiftReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(assignShiftError.message)
        }
        if (assignShiftReqStatus?.length) {
            dispatch(assignShiftRequestStatus(''))
        }
    }, [assignShiftSuccess, assignShiftError, assignShiftReqStatus])

    useEffect(() => {
        if (shiftRemoveEmployeeReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(shiftRemoveEmployeeSuccess.data.message)
            fetchShiftDetail()
        } else if (shiftRemoveEmployeeReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(shiftRemoveEmployeeError.message)
        }
        if (shiftRemoveEmployeeReqStatus?.length) {
            dispatch(removeShiftEmployeeRequestStatus(''))
        }
    }, [shiftRemoveEmployeeSuccess, shiftRemoveEmployeeError, shiftRemoveEmployeeReqStatus])

    useEffect(() => {
        if (declineRequestReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(declineRequestSuccess.data.message)
            fetchShiftDetail()
        } else if (declineRequestReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(declineRequestError.message)
        }
        if (declineRequestReqStatus?.length) {
            dispatch(declineRequestShiftRequestStatus(''))
        }
    }, [declineRequestSuccess, declineRequestError, declineRequestReqStatus])

    const getStatusClassname = (status) => {
        if (status === true) {
            return 'pd-status-container pd-status-container-complete'
        } else {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const getShiftAddress = (shiftData) => {
        let address = `${!isEmpty(shiftData.city) ? `${shiftData.city}, ` : ''}${!isEmpty(shiftData.state) ? `${shiftData.state}, ` : ''}${!isEmpty(shiftData.country) ? `${shiftData.country}, ` : ''}`
        return address
    }

    const isPermissionAllowed = (reqType) => {
        if (reqType === PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SHIFT, PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT, state.businessId, state.locationId)
        } else if (reqType === PERMISSION_SUB_TYPE.SHIFT.ACCEPT_REJECT_EMPLOYEE_REQUEST) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SHIFT, PERMISSION_SUB_TYPE.SHIFT.ACCEPT_REJECT_EMPLOYEE_REQUEST, state.businessId, state.locationId)
        }
    }

    const handleUpdateShiftDetails = (updateType = UPDATE_TYPE.GENERAL, flag) => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try again.')
        } else {
            setLoading(true)
            const data = {
                shiftId: state.shiftId
            }
            if (updateType === UPDATE_TYPE.STATUS) {
                data.isActive = flag
            }
            if (updateType === UPDATE_TYPE.NOMINATION) {
                data.openForNomination = flag
            }
            dispatch(updateShiftRequest(data))
        }
    }

    const handleRequestShiftClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try again.')
        } else {
            setLoading(true)
            const data = {
                shiftId: state.shiftId,
                id: isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                userType: user.data.userDetails.userType
            }
            dispatch(requestShiftRequest(data))
        }
    }

    const handleAssignClick = (element) => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(element.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                displayErrorToast('Cannot approve self request')
                return
            }
            setLoading(true)
            const data = {
                id: element.employeeId,
                userType: element.userType,
                shiftId: state.shiftId
            }
            dispatch(assignShiftRequest(data))
        }
    }

    const handleRejectClick = (element) => {
        setSelectedEmployee(element)
        setShowRejectModal(true)
    }

    const handleRejectSubmitClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(selectedEmployee)) {
            displayErrorToast('Employee information not available. Please try again')
        } else if (isEmpty(reason)) {
            displayErrorToast('Decline reason cannot be blank')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(selectedEmployee.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                displayErrorToast('Cannot decline self request')
                return
            }
            setLoading(true)
            const data = {
                id: selectedEmployee.employeeId,
                userType: selectedEmployee.userType,
                shiftId: state.shiftId,
                rejectReason: reason
            }
            dispatch(declineRequestShiftRequest(data))
        }
    }

    const handleRemoveEmpClick = (element) => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (!isPermissionAllowed(PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT)) {
            displayErrorToast('Permission not allowed to update shift details')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(element.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                displayErrorToast('Cannot remove self from project')
                return
            }
            setLoading(true)
            const data = {
                id: element.employeeId,
                userType: element.userType,
                shiftId: state.shiftId
            }
            dispatch(removeShiftEmployeeRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Shift Detail' />
                {!isEmpty(shiftDetailSuccess) && !isEmpty(shiftDetailSuccess.data) && <CommonFormBorder>
                    <div className="pd-img-parent-container">
                        <div className="pd-img-container">
                            <img src={require('../../../assets/logo_togethra.png')} className="img" />
                        </div>
                    </div>
                    <div className={getStatusClassname(shiftDetailSuccess.data.isActive)}>{shiftDetailSuccess.data.isActive ? 'Active' : 'In Active'}</div>
                    <div className="pd-name-label">{shiftDetailSuccess.data.name}</div>
                    <div className="pd-description-label">{shiftDetailSuccess.data.description}</div>
                    <FormFieldLabel label='Shift Location' />
                    {!isEmpty(shiftDetailSuccess.data.location?.address) && <div className="pd-address">{shiftDetailSuccess.data.location?.address}</div>}
                    {!isEmpty(getShiftAddress(shiftDetailSuccess.data.location)) && <div className="pd-address mb-2">{getShiftAddress(shiftDetailSuccess.data.location)}</div>}
                    <div className="pd-icon-row-container">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_calendar.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">{moment.utc(shiftDetailSuccess.data.startDate).local().format('DD MMM YYYY')} - {moment.utc(shiftDetailSuccess.data.endDate).local().format('DD MMM YYYY')}</div>
                    </div>
                    <div className="pd-icon-row-container">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_clock.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">{moment.utc(shiftDetailSuccess.data.startTime).local().format('hh:mm A')} - {moment.utc(shiftDetailSuccess.data.endTime).local().format('hh:mm A')}</div>
                    </div>
                    <FormFieldLabel label='Assigned Employees' />
                    {!isEmpty(shiftDetailSuccess.data.assignedEmployeeDetails) && <div>
                        <div className="sd-ae-list-container">
                            {shiftDetailSuccess.data.assignedEmployeeDetails.map(e => (<div className="sd-as-list-row-container">
                                <div className="pd-address">{e.firstName} {e.lastName}</div>
                                <div className="pd-icon-label">{e.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${e.employeeBusinessMapping[0].employeeCode}` : `${removeSpecialCharAndChangeToPascal(e.userType)}`}</div>
                                <div className="sd-ae-btn-row">
                                    <div className="in-active" onClick={() => { handleRemoveEmpClick(e) }}>Remove</div>
                                </div>
                            </div>))}
                        </div>
                    </div>}
                    {isEmpty(shiftDetailSuccess.data.assignedEmployeeDetails) && <div className="content-error">No employee assigned on shift</div>}
                    {isPermissionAllowed(PERMISSION_SUB_TYPE.SHIFT.ACCEPT_REJECT_EMPLOYEE_REQUEST) && <div>
                        <FormFieldLabel label='Employees Requests' />
                        {!isEmpty(shiftDetailSuccess.data.employeeRequestDetails) && <div>
                            <div className="sd-ae-list-container">
                                {shiftDetailSuccess.data.employeeRequestDetails.map(e => (<div className="sd-as-list-row-container">
                                    <div className="pd-address">{e.firstName} {e.lastName}</div>
                                    <div className="pd-icon-label">{e.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${e.employeeBusinessMapping[0].employeeCode}` : `${removeSpecialCharAndChangeToPascal(e.userType)}`}</div>
                                    <div className="sd-ae-btn-row">
                                        <div className="active" onClick={() => { handleAssignClick(e) }}>Accept</div>
                                        <div className="in-active me-2" onClick={() => { handleRejectClick(e) }}>Decline</div>
                                    </div>
                                </div>))}
                            </div>
                        </div>}
                        {isEmpty(shiftDetailSuccess.data.employeeRequestDetails) && <div className="content-error">No employee request for assignment</div>}
                    </div>}
                    <ButtonRow isVertical={true}>
                        {isLoggedInUserEmployee(user) && shiftDetailSuccess.data.openForNomination === true && <CommonButton isBig={true} label='Request Shift' onClick={() => { handleRequestShiftClick() }} />}
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT) && shiftDetailSuccess.data.openForNomination === true && <CommonButton isBig={true} label='Close Nominations' onClick={() => { handleUpdateShiftDetails(UPDATE_TYPE.NOMINATION, false) }} />}
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT) && shiftDetailSuccess.data.openForNomination === false && <CommonButton isBig={true} label='Open Nominations' onClick={() => { handleUpdateShiftDetails(UPDATE_TYPE.NOMINATION, true) }} />}
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT) && shiftDetailSuccess.data.isActive === true && <CommonButton isBig={true} label='Mark In Active' onClick={() => { handleUpdateShiftDetails(UPDATE_TYPE.STATUS, false) }} />}
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT) && shiftDetailSuccess.data.isActive === false && <CommonButton isBig={true} label='Mark Active' onClick={() => { handleUpdateShiftDetails(UPDATE_TYPE.STATUS, true) }} />}
                    </ButtonRow>
                </CommonFormBorder>}
                {!isEmpty(shiftDetailError) && <div className="content-error">{shiftDetailError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowRejectModal(false) }}
                show={showRejectModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Reject request
                </Modal.Header>
                <Modal.Body>
                    <CommonInputFloatFull
                        type='text'
                        id='reason'
                        onChange={e => setReason(e.target.value)}
                        placeholder='Decline reason'
                        value={reason}
                        multiline={true}
                        rows={3}
                    />
                    <ButtonRow>
                        <CommonButton label='Submit'
                            onClick={() => {
                                handleRejectSubmitClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default ShiftDetail